import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppNotificationsService } from '@deltager/organizers/admin/core/services/app-notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '@deltager/organizers/admin/core/services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizerValidationService {
  validateUrl = `${environment.paymentApiURL}/validate/`;

  constructor(
    private http: HttpClient,
    private appNotificationService: AppNotificationsService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private translate: TranslateService,
  ) {}

  getBankIdValidationUrl(accountId: number, callbackUrl: string): Observable<string> {
    const request = { organizerId: accountId, callbackUrl: callbackUrl };
    return this.http.post(this.validateUrl + 'bankid/identity', request).pipe(map(response => response as string));
  }

  urlHasIdentityValidationResponse(fromEventSetup: boolean): boolean {
    if (!this.route.snapshot.queryParamMap.has('idValidation')) return false;

    const result = +this.route.snapshot.queryParamMap.get('idValidation') > 0;
    this.showValidationResponseMessage(result, fromEventSetup);

    return true;
  }

  private showValidationResponseMessage(result: boolean, fromEventSetup: boolean) {
    // Check if already shown
    if (+this.storageService.getItemFromSession('id_msg_shown') > 0) return;

    if (result) {
      const text = fromEventSetup
        ? 'organizer.validate_identity_es_status_success'
        : 'organizer.validate_identity_status_success';
      this.appNotificationService.sendSuccess({
        title: this.translate.instant(text),
      });

      this.storageService.setItemInSession('id_msg_shown', 1);
    } else {
      this.appNotificationService.sendError({
        title: this.translate.instant('validation.validate_identity_status_failed'),
      });
    }
  }
}
